const formats = {
    date_format: "DD/MM/YYYY",
    time_format: "HH:mm:ss",
    twelve_hours_time_format: "hh:mm a",
    date_time_format: "DD/MM/YYYY hh:mm a"
}

module.exports = formats;
